<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-md-offset-4 col-md-4">
            <card>
                <div class="header">
                    <h4 class="title">Esqueci Minha Senha</h4>
                </div>
                <div class="content">
                    <form @submit.prevent.stop='login()'>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Username</label>
                                    <input type="text" v-model="username" name='username' class="form-control border-input" required placeholder="Username">
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <button type="submit" class="btn btn-info btn-fill btn-wd">Enviar</button>
                        </div>
                        <div class="clearfix"></div>
                    </form>
                </div>
            </card>
        </div>
    </div>
</div>
</template>
<script>

import AuthService from '../services/auth-service'

export default {

  data () {
    return {
      username: undefined,
      password: undefined
    }
  },
  methods: {
    login () {
      AuthService.passwordForgot(this.username).then(({ data }) => {
        this.$alertify.success('Link enviado para seu email: ' + data.email)
      }).catch(() => {
        this.$alertify.error('Erro')
      })
    }
  }

}
</script>

